//@state
export interface taskState {
  task:boolean
}

export const initialState: taskState = {
  task:true
}
